import { HttpBackend, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class MediaService {
  private customHttpClient: HttpClient;

  constructor(
    private httpBackend: HttpBackend
  ) {
    // skip HTTP_INTERCEPTORS by creating custom HttpClient
    this.customHttpClient = new HttpClient(this.httpBackend);
  }

  uploadFile(url: string, body: File | Blob): Observable<string> {
    return this.customHttpClient.put(url, body, {
      headers: {
        'x-ms-blob-type': 'BlockBlob'
      }
    }).pipe(map(() => ''));
  }

  deleteFile(url: string): Observable<string> {
    return this.customHttpClient.delete(url, {
      headers: {}
    }).pipe(map(() => ''));
  }
}
